import React, { useState, useEffect } from "react";
import "../../Assets/styles/Countdown.css";

const CountdownSection = ({ targetDate }) => {
  const [timeRemaining, setTimeRemaining] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(targetDate).getTime() - now;

      if (distance <= 0) {
        clearInterval(interval);
        setTimeRemaining({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
      } else {
        setTimeRemaining({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [targetDate]);

  return (
    <div className="countdown-section">
      <h2>TEMPO RESTANTE PARA O NOSSO DIA</h2>
      <div className="timer">
        <div className="timer-item">
          <p>{timeRemaining.days}</p>
          <span>Dias</span>
        </div>
        <div className="timer-item">
          <p>{timeRemaining.hours}</p>
          <span>Horas</span>
        </div>
        <div className="timer-item">
          <p>{timeRemaining.minutes}</p>
          <span>Minutos</span>
        </div>
        <div className="timer-item">
          <p>{timeRemaining.seconds}</p>
          <span>Segundos</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownSection;
